function isEqual(value: unknown, other: unknown): boolean {
    // Primitive comparison or strict equality
    if (value === other) {
        return true;
    }

    // Null check
    if (value == null || other == null) {
        return false;
    }

    // Compare arrays
    if (Array.isArray(value) && Array.isArray(other)) {
        if (value.length !== other.length) {
            return false;
        }

        for (let i = 0; i < value.length; i++) {
            if (!isEqual(value[i], other[i])) {
                return false;
            }
        }

        return true;
    }

    // Compare objects
    if (typeof value === 'object' && typeof other === 'object') {
        const keysA = Object.keys(value);
        const keysB = Object.keys(other);

        if (keysA.length !== keysB.length) {
            return false;
        }

        for (const key of keysA) {
            if (!Object.hasOwn(other, key)) {
                return false;
            }

            if (!isEqual(value[key], other[key])) {
                return false;
            }
        }

        return true;
    }

    // Compare functions
    if (typeof value === 'function' && typeof other === 'function') {
        return value.toString() === other.toString();
    }

    // Fallback (e.g., different types or unhandled cases)
    return false;
}

// ----------------------------------------------------------------------------

export default isEqual;
